import { Collaboration } from '../types';

const DRAFT_KEY = 'collaboration_draft';

export interface CollaborationDraft {
  formData: {
    title: string;
    project_description: string;
    place: string;
    is_paid: boolean;
    budget: string | number;
    duration: string;
    start_date: string;
    end_date: string;
    creator_insights: string;
    creator_role: string;
  };
  tags: string[];
  collaborators: any[]; // Using any[] to match the component's flexible structure for now, ideally should be Collaborator[]
  images: string[]; // Base64 strings
  timestamp: number;
}

export const saveDraft = (data: Omit<CollaborationDraft, 'timestamp'>) => {
  try {
    const draft: CollaborationDraft = {
      ...data,
      timestamp: Date.now(),
    };
    localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
    return true;
  } catch (error) {
    console.error('Failed to save draft:', error);
    return false;
  }
};

export const loadDraft = (): CollaborationDraft | null => {
  try {
    const draftStr = localStorage.getItem(DRAFT_KEY);
    if (!draftStr) return null;
    return JSON.parse(draftStr);
  } catch (error) {
    console.error('Failed to load draft:', error);
    return null;
  }
};

export const clearDraft = () => {
  try {
    localStorage.removeItem(DRAFT_KEY);
  } catch (error) {
    console.error('Failed to clear draft:', error);
  }
};

export const hasDraft = (): boolean => {
  return !!localStorage.getItem(DRAFT_KEY);
};
